"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useContainerStyle = (style, parent) => (0, react_1.useMemo)(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const computedStyle = {
        flexDirection: (style === null || style === void 0 ? void 0 : style.flexDirection) || 'column',
        justifyContent: style === null || style === void 0 ? void 0 : style.justifyContent,
        alignItems: style === null || style === void 0 ? void 0 : style.alignItems,
        paddingBottom: style === null || style === void 0 ? void 0 : style.paddingBottom,
        paddingLeft: style === null || style === void 0 ? void 0 : style.paddingLeft,
        paddingRight: style === null || style === void 0 ? void 0 : style.paddingRight,
        paddingTop: style === null || style === void 0 ? void 0 : style.paddingTop,
        marginBottom: style === null || style === void 0 ? void 0 : style.marginBottom,
        marginLeft: style === null || style === void 0 ? void 0 : style.marginLeft,
        marginRight: style === null || style === void 0 ? void 0 : style.marginRight,
        marginTop: style === null || style === void 0 ? void 0 : style.marginTop,
        borderBottomLeftRadius: style === null || style === void 0 ? void 0 : style.borderBottomLeftRadius,
        borderBottomRightRadius: style === null || style === void 0 ? void 0 : style.borderBottomRightRadius,
        borderTopLeftRadius: style === null || style === void 0 ? void 0 : style.borderTopLeftRadius,
        borderTopRightRadius: style === null || style === void 0 ? void 0 : style.borderTopRightRadius,
        borderTopWidth: (style === null || style === void 0 ? void 0 : style.borderTopWidth) || 0,
        borderRightWidth: (style === null || style === void 0 ? void 0 : style.borderRightWidth) || 0,
        borderBottomWidth: (style === null || style === void 0 ? void 0 : style.borderBottomWidth) || 0,
        borderLeftWidth: (style === null || style === void 0 ? void 0 : style.borderLeftWidth) || 0,
        backgroundColor: style === null || style === void 0 ? void 0 : style.background,
        borderColor: style === null || style === void 0 ? void 0 : style.borderColor,
        width: style === null || style === void 0 ? void 0 : style.width,
        height: style === null || style === void 0 ? void 0 : style.height,
        heightAuto: style === null || style === void 0 ? void 0 : style.heightAuto,
        borderStyle: style === null || style === void 0 ? void 0 : style.borderStyle,
        zIndex: (style === null || style === void 0 ? void 0 : style.zIndex) ? Math.min(style.zIndex, 10) : undefined,
        shadowColor: style === null || style === void 0 ? void 0 : style.shadowColor,
        shadowOffset: style === null || style === void 0 ? void 0 : style.shadowOffset,
        shadowOpacity: style === null || style === void 0 ? void 0 : style.shadowOpacity,
        shadowRadius: style === null || style === void 0 ? void 0 : style.shadowRadius,
        elevation: style === null || style === void 0 ? void 0 : style.elevation,
        position: (_a = style === null || style === void 0 ? void 0 : style.position) !== null && _a !== void 0 ? _a : 'relative',
        top: style === null || style === void 0 ? void 0 : style.top,
        left: style === null || style === void 0 ? void 0 : style.left,
        right: style === null || style === void 0 ? void 0 : style.right,
        bottom: style === null || style === void 0 ? void 0 : style.bottom,
    };
    if ((parent === null || parent === void 0 ? void 0 : parent.tag) === 'View') {
        if (parent.containerType === 'wrapper') {
            if ((_b = parent.style) === null || _b === void 0 ? void 0 : _b.flexDirection) {
                computedStyle.flexDirection = (_c = parent.style) === null || _c === void 0 ? void 0 : _c.flexDirection;
            }
            if ((_d = parent.style) === null || _d === void 0 ? void 0 : _d.alignItems) {
                computedStyle.alignItems = (_e = parent.style) === null || _e === void 0 ? void 0 : _e.alignItems;
            }
            if ((_f = parent.style) === null || _f === void 0 ? void 0 : _f.justifyContent) {
                computedStyle.justifyContent = (_g = parent.style) === null || _g === void 0 ? void 0 : _g.justifyContent;
            }
            if (parent.scroll) {
                if (parent.scroll.vertical) {
                    if (computedStyle.flexDirection === 'column-reverse') {
                        computedStyle.justifyContent = 'flex-end';
                    }
                    else if (computedStyle.flexDirection === 'column') {
                        computedStyle.justifyContent = 'flex-start';
                    }
                }
                if (parent.scroll.horizontal) {
                    if (computedStyle.flexDirection === 'row-reverse') {
                        computedStyle.justifyContent = 'flex-end';
                    }
                    if (computedStyle.flexDirection === 'row') {
                        computedStyle.justifyContent = 'flex-start';
                    }
                }
            }
            if (!computedStyle.backgroundColor
                || (computedStyle.backgroundColor.type === 'custom'
                    && computedStyle.backgroundColor.value === 'transparent')) {
                delete computedStyle.shadowColor;
                delete computedStyle.shadowOffset;
                delete computedStyle.shadowOpacity;
                delete computedStyle.shadowRadius;
                delete computedStyle.elevation;
            }
        }
    }
    if ((parent === null || parent === void 0 ? void 0 : parent.tag) === 'Swiper' && parent.containerType === 'wrapper') {
        if ((_h = parent.style) === null || _h === void 0 ? void 0 : _h.flexDirection) {
            computedStyle.flexDirection = (_j = parent.style) === null || _j === void 0 ? void 0 : _j.flexDirection;
        }
    }
    return computedStyle;
}, [style, parent]);
exports.default = useContainerStyle;
